import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export function Skeleton({ className }: { className?: string }): ReactNode {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-white/[0.03] animate-[skeleton-in_200ms_ease-out]',
        className
      )}
    />
  );
}
